module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-24-331aeb0100fdaf40ee69c9edfd03f91a.png";